import { ReactNode } from 'react';
import styles from './Divider.module.scss';

type DividerProps = {
  /** Height of the separator (in pixels) */
  height: number;
  /** Default width is full */
  width?: 'full' | 'large' | 'medium' | 'small';
  /** Optional divider text */
  children?: ReactNode;
  /** Whether this should act as a semantic separator or be hidden from screen readers */
  'aria-hidden'?: boolean;
};

/**
 * Renders a horizontal rule with optional text dividing the middle of it. Used
 * to create visual separation between related content.
 */
export const Divider = ({
  height,
  width = 'full',
  children,
  'aria-hidden': ariaHidden = undefined,
}: DividerProps) => {
  return (
    <div
      role="separator"
      aria-hidden={ariaHidden}
      className={styles.root}
      style={{ '--zds-internal-divider-height': `${height}px` }}
      data-width={width}
    >
      {children && <span className={styles.content}>{children}</span>}
    </div>
  );
};
